/**
 * Decode JWT token and extract payload
 * @param {string} token - JWT token string
 * @returns {Object|null} - Decoded payload or null if invalid
 */
export function decodeToken(token) {
  if (!token || typeof token !== "string") {
    return null;
  }

  try {
    // JWT tokens have 3 parts: header.payload.signature
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];

    // Base64 decode and parse JSON
    // Replace URL-safe base64 characters if needed
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}

/**
 * Get role information from token stored in localStorage
 * @returns {Object|null} - Role information with roleId, roleName, or null if not found
 */
export function getRoleFromToken() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return null;
    }

    const decoded = decodeToken(token);
    if (!decoded) {
      return null;
    }

    const roleName =
      decoded.roleName ??
      decoded.role_name ??
      (typeof decoded.role === "string" ? decoded.role : null) ??
      decoded.role?.name ??
      null;

    return {
      roleId: decoded.roleId ?? decoded.role_id ?? null,
      roleName,
      userId: decoded.userId ?? decoded.user_id ?? null,
    };
  } catch (error) {
    console.error("Error getting role from token:", error);
    return null;
  }
}
